import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

import vuetify from '@/plugins/vuetify'
import DatetimePicker from 'vuetify-datetime-picker'
// (Optional) import 'vuetify-datetime-picker/src/stylus/main.styl'
 
Vue.use(DatetimePicker)

import 'material-design-icons-iconfont/dist/material-design-icons.css'
import '@mdi/font/css/materialdesignicons.css'

import VueSocketIO from 'vue-socket.io'
import config from './api/config'

var moment = require('moment');
moment.suppressDeprecationWarnings = true;
Vue.use(moment); 


function lsTest(){
  var test = 'test';
  try {
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
  } catch(e) {
      return false;
  }
}

if(lsTest() === true) {
  // Cookie check
  console.log("Cookies is available do nothing")
}else{
  console.log("NotAvailable")
  alert("Du måste ha cookies tillåtna för att det ska fungera att chatta. Aktivera cookies i din webbläsare och försök igen");
  window.location = 'https://mind.se';

}



const io = require("socket.io-client");
 
Vue.use(new VueSocketIO({
    debug: false,
    connection: io.io(config.devServer +'/chat/events', {
      transports: ['websocket'], 
      upgrade: true,
      reconnectionDelay: 1000
    })
  })
);

let localVid = '';
const uniqueId = Math.random().toString(36).substring(2) + Date.now().toString(36);

try {
  localVid = localStorage.getItem("visitorId")

  if (localVid == null || localVid == 'null') {

    // Generate random key
    // Store it on the users computer
    localStorage.setItem('visitorId', uniqueId);
  
  }

} catch (error) {
  console.log("OK");
}

function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
    /[xy]/g,
    function(c) {
      var r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8
      return v.toString(16)
    }
  )
}

if(localStorage.getItem('___user-guid')) {
  // get value from cookie with name mind-guid
  let cookieValue = localStorage.getItem('___user-guid');
  console.log("Anon user is knonwn",cookieValue);  
} else {
  localStorage.setItem('___user-guid', uuidv4());
  console.log("First visit from user");
}

Vue.config.productionTip = false

const app = new Vue({
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')
